import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";
import {BsModalService} from "ngx-bootstrap";
import {ImageCroppedEvent} from "ngx-image-cropper";

@Component({
  selector: 'app-resort-package-create',
  templateUrl: './resort-package-create.component.html',
  styleUrls: ['./resort-package-create.component.scss']
})
export class ResortPackageCreateComponent implements OnInit,OnDestroy {
  imageChangedEvent: any;
  showCropper: any;
  croppedImage: any = '';
  // showCropper = false;
  imageCropper: any;
  packForm: any;
  isloading: boolean;

  excluArray : Array<any> = [];
  incluArray : Array<any> = [];
  incluForm: any;
  exclueForm: any;
  catgorys: any;
  type: any;
  removeEvt: any;
  update: any;
  isUpdate: string;

  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService,) {
    this.isUpdate = localStorage.getItem('packUpdate');
    this.packForm = this.formBuilder.group({
      packageName: ["", [Validators.required]],
      packagePrice: ["", [Validators.required]],
      title: ["",],
      type: ["", [Validators.required]],
      nodate: ["", [Validators.required]],
      promotion: ["", [Validators.required]],
    });

    this.incluForm = this.formBuilder.group({
      inclue: ["", [Validators.required]],
    });

    this.exclueForm = this.formBuilder.group({
      exclue: ["", [Validators.required]],
    });
  }

  ngOnInit() {
    this.getAllCategory();
    this.getAllType();
    if (localStorage.getItem('packUpdate') == 'true') {
      this.update = JSON.parse(localStorage.getItem('packUpdateData'));
      this.setUpdateData();
    }
  }

  ngOnDestroy(): void {
    localStorage.setItem('packUpdate','false');
  }


  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.file;
  }

  imageLoaded() {
    this.showCropper = true;
  }

  rotateLeft() {
    this.imageCropper.rotateLeft();
  }

  rotateRight() {
    this.imageCropper.rotateRight();
  }

  flipHorizontal() {
    this.imageCropper.flipHorizontal();
  }

  flipVertical() {
    this.imageCropper.flipVertical();
  }

  public finishWizard(type, message) {
    // this.notifier.notify( type, message );
  }

  files: File[] = [];

  onSelect(event) {
    console.log(event);
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.removeEvt=event;
    this.files.splice(this.files.indexOf(event), 1);
  }
  createPackage() {
    this.isloading = true;
    let req = {
      noOfDays: this.packForm.controls.nodate.value,
      packageName: this.packForm.controls.packageName.value,
      packagePrice: this.packForm.controls.packagePrice.value,
      promotion: this.packForm.controls.promotion.value,
      type: this.packForm.controls.type.value,
      exclustionsDTOList:this.excluArray,
      inclusionsDTOList:this.incluArray,
    }
    this.userService.createPackage(req).subscribe(
      res => {
        if (res.responseCode == 200) {
          this.upload(res.data);
          this.isloading = false;
          this.notifier.notify('success', res.responseDesc);
          this.packForm.reset();
          this.incluArray=[]
          this.excluArray=[]
          this.incluForm.reset();
          this.exclueForm.reset()
          this.imageChangedEvent = '';
          this.croppedImage = '';
          this.showCropper = false;
          this.imageCropper = '';
          this.onRemove(this.removeEvt);
        } else {
          this.isloading = false;
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  updatePackage() {
    this.isloading = true;
    let req = {
      id:this.update.id,
      noOfDays: this.packForm.controls.nodate.value,
      packageName: this.packForm.controls.packageName.value,
      packagePrice: this.packForm.controls.packagePrice.value,
      promotion: this.packForm.controls.promotion.value,
      type: this.packForm.controls.type.value,
      exclustionsDTOList:this.excluArray,
      inclusionsDTOList:this.incluArray,
    }
    this.userService.createPackage(req).subscribe(
      res => {
        if (res.responseCode == 200) {
          this.upload(res.data);
          this.isloading = false;
          this.notifier.notify('success', res.responseDesc);
          this.packForm.reset();
          this.incluArray=[]
          this.excluArray=[]
          this.incluForm.reset();
          this.exclueForm.reset()
          this.onRemove(this.removeEvt);
        } else {
          this.isloading = false;
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  getAllCategory() {
    this.userService.getAllCategory().subscribe(
      res => {
        if (res.responseCode == 200) {
          this.catgorys = res.data;
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  getAllType() {
    this.userService.getAllType().subscribe(
      res => {
        if (res.responseCode == 200) {
          this.type = res.data;
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  upload(id) {
    this.userService.uploadPackageImg( this.files[0],id).subscribe(
      data => {
        if(data.responseCode==200){
          this.notifier.notify('success', data.responseDesc);
        }else {
          this.notifier.notify('danger', 'Somthing went wrong faild to upload image.');
        }
      });
  }

  inclueAdd() {
    this.incluArray.push({
      description:this.incluForm.controls.inclue.value,
    })
    this.incluForm.reset();
  }

  exclueAdd() {
    this.excluArray.push({
      description:this.exclueForm.controls.exclue.value,
    })
    this.exclueForm.reset();
  }

  removeInclue(des) {
    for (let i = 0; i < this.incluArray.length; ++i) {
      if (this.incluArray[i].description === des) {
        this.incluArray.splice(i, 1);
      }
    }
  }

  removeExclue(des) {
    for (let i = 0; i < this.excluArray.length; ++i) {
      if (this.excluArray[i].description === des) {
        this.excluArray.splice(i, 1);
      }
    }
  }

  setUpdateData() {
    this.packForm.controls['packageName'].setValue(this.update.packageName);
    this.packForm.controls['packagePrice'].setValue(this.update.packagePrice);
    this.packForm.controls['type'].setValue(this.update.travelType.id);
    this.packForm.controls['nodate'].setValue(this.update.noOfDays);
    this.packForm.controls['categoryId'].setValue(this.update.packageCategory.id);
    this.packForm.controls['promotion'].setValue(this.update.promotion);
    this.incluArray=this.update.exclusionsList;
    this.excluArray=this.update.inclusionsList;
  }


  inclueClick(description) {
    this.incluForm.controls['inclue'].setValue(description);
  }
  exclueClick(description) {
    this.exclueForm.controls['exclue'].setValue(description);
  }
}
